import {
  LOYALTY_ULTRA_LUX_CAMPAIGN_EARN_KEY,
  LOYALTY_GARUDA_BONUS_POINTS_CAMPAIGN_EARN_KEY,
} from 'loyalty/constants/loyaltyEarn'

export function getLoyaltyBedbankPackageId(propertyId: string | undefined, supplierCode: string | undefined) {
  if (!propertyId || !supplierCode) return ''
  return `${propertyId}:${supplierCode}`
}

interface LoyaltyEarnKeyRentalOptions {
  propertyCountryCode: string | undefined
}

interface LoyaltyEarnKeyBedbankOptions {
  propertyCountryCode: string | undefined
  propertyState: string | undefined
  currentRegionCode?: string
  propertyId?: string
  supplierCode?: string
}

interface LoyaltyEarnKeyFlashOptions {
  propertyCountryCode: string | undefined
  propertyState: string | undefined
  currentRegionCode: string
}

interface LoyaltyEarnKeyAlwaysOnOptions {
  propertyCountryCode: string | undefined
  propertyState: string | undefined
  currentRegionCode: string
  isUltraLux: boolean
}

interface LoyaltyEarnKeyFlightOptions {
  originAirportCode: string
  destinationAirportCode: string
  carrier: string
  loyaltyEarnKey?: string
}

// Add additional loyalty product types here
type LoyaltyProductTypeWithOptions = 'hotel_lpc' | 'hotel_lpp_eps' | 'hotel_flash' | 'rental' | App.LoyaltyFlightProductType

type LoyaltyEarnKeyConfig =
  | { loyaltyProductType: 'hotel_lpc', options: LoyaltyEarnKeyAlwaysOnOptions }
  | { loyaltyProductType: 'hotel_flash', options: LoyaltyEarnKeyFlashOptions }
  | { loyaltyProductType: 'hotel_lpp_eps', options: LoyaltyEarnKeyBedbankOptions }
  | { loyaltyProductType: 'rental', options: LoyaltyEarnKeyRentalOptions }
  | { loyaltyProductType: App.LoyaltyFlightProductType, options: LoyaltyEarnKeyFlightOptions }
  // Add other verticals / loyalty product types here
  | { loyaltyProductType: Exclude<App.LoyaltyProductType, LoyaltyProductTypeWithOptions>, options?: undefined }

const FLIGHTS_EARN_KEYS = [
  LOYALTY_GARUDA_BONUS_POINTS_CAMPAIGN_EARN_KEY,
] as const

function getLoyaltyEarnKey(config: LoyaltyEarnKeyConfig): string | undefined {
  switch (config.loyaltyProductType) {
    case 'hotel_lpc':
    {
      if (config.options.isUltraLux) {
        return LOYALTY_ULTRA_LUX_CAMPAIGN_EARN_KEY
      }
      return undefined
    }
    case 'hotel_lpp_eps':
      return getLoyaltyBedbankPackageId(config.options.propertyId, config.options.supplierCode) || undefined
    case 'hotel_flash':
    case 'rental':
      return undefined
    case 'int_economy':
    case 'int_premium_economy':
    case 'int_business':
    case 'int_first':
    case 'dom_economy':
    case 'dom_business':
      const { originAirportCode, destinationAirportCode, carrier, loyaltyEarnKey } = config.options

      if (loyaltyEarnKey) return loyaltyEarnKey

      /**
       * @NOTE Return the first earn key that matches the criteria
       * @TODO add other earn keys and extract to a lib function if it gets bloated
       */
      let matchedEarnKey: string | undefined

      FLIGHTS_EARN_KEYS.forEach(earnKey => {
        switch (earnKey) {
          case LOYALTY_GARUDA_BONUS_POINTS_CAMPAIGN_EARN_KEY:
            // The carrier must be Garuda Indonesia
            if (carrier !== 'GA') return

            // The destination or origin must be Denpasar
            if (destinationAirportCode !== 'DPS' && originAirportCode !== 'DPS') return

            // The destination or origin must be Melbourne
            if (destinationAirportCode !== 'MEL' && originAirportCode !== 'MEL') return
            matchedEarnKey = earnKey
            break
        }
      })

      return matchedEarnKey
    default:
      return undefined
  }
}

export default getLoyaltyEarnKey
